<template>
  <div class="__wrapper">
    <div class="__toolbar">
      <div class="content-wrapper">
        <div class="__logo">
          <img @click="goto('/')" src="../assets/icons/log2.svg" width="156px" />
        </div>
        <div class="__buttons">
          <button class="sign_in_btn" @click="login">Sign In</button>
          <button class="register_btn" @click="signUp">Register</button>
        </div>
      </div>
    </div>

    <div class="hero">
      <div class="content-wrapper">
        <img @click="goto('/')" src="../assets/images/logo/white_logo.svg" />
        <div class="phone__buttons">
          <button class="sign_in_btn" @click="login">Sign In</button>
          <button class="register_btn" @click="sendShit">Register</button>
        </div>
        <div class="about-section">
          <div class="about-col fist-content">
            <!-- <img src="../assets/images/about_content_1.svg" alt /> -->
            <h2 class="text-center">Get your Consultant profile visible</h2>
            <p>
              Consultified is a platform created by consultants for consultants in
              order to bridge the gap in the consultant market. By using
              Consultified, consultants get visibility and enrich their consultant
              profiles in collaboration with others in the consultant market.
            </p>
          </div>
          <div class="about-col second-content">
            <!-- <img src="../assets/images/about_content_2.svg" alt /> -->
            <h2 class="text-center">
              Find the right competence and Consultant
            </h2>
            <p>
              Consultified is a platform created by consultants to bridge the gap in
              the consultant market and simplify the search and selection of
              available candidates while adressing the information distribution
              issue with CVs and GDPR.
            </p>
          </div>
          <div class="about-col free-anouncement third-content">
            <!-- <img src="../assets/images/about_content_2.svg" alt /> -->
            <h2 class="text-center">Its Free!</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="main-about">
      <div class="main-about-content">
        <p>Consultified is a Swedish company that enables more effective resource management for suppliers and customers in the consultant market. Our goal is to reduce the Cost of Accuisition by simplifying the search and selection of candidates for the customers and provide a broader selection of leads for consultants and consultant companies. We achieve this by having a growing database with standardized CVs with a high granularity on consultant availability and searchable skill categories on consultants as well as leads.</p>
      </div>
    </div>-->

    <div class="__footer">
      <div class="footer-logo">
        <img @click="goto('/')" src="../assets/images/logo/log__footer.svg" />
      </div>
      <ul class="menu">
        <li @click="goto('/about-us')">About Us</li>
        <li :class="{ __active: showContact }" @click="() => {
            showTab1 = true;
            showTab2 = false;
            showContact = true;
          }
          ">
          Press contact
        </li>

        <!-- <li @click="openForum">Our Forum</li> -->
      </ul>
    </div>

    <div class="home-dialog">
      <template>
        <v-dialog v-model="showContact">
          <v-card color="#D2D1D1">
            <v-layout>
              <div class="cover__body">
                <h2>E-mail</h2>
                <input type="text" v-model="contact.mail_from" />
                <h2>Message</h2>
                <textarea v-model="contact.mail_body"
                  placeholder="If you send us a press inquiry a member of our team will get back to you shortly."></textarea>
                <div class="btns">
                  <button class="ok-btn" @click="sendContactMail">Send</button>
                  <button class="cancel-btn" @click="() => {
                      showContact = false;
                    }
                    ">
                    Cancel
                  </button>
                </div>
              </div>
            </v-layout>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog v-model="showInvestor">
          <v-card color="#D2D1D1">
            <v-layout>
              <div class="cover__body">
                <h2>E-mail</h2>
                <input type="text" v-model="investor.mail_from" />
                <h2>Message</h2>
                <textarea v-model="investor.mail_body"
                  placeholder="If you send us a press inquiry a member of our team will get back to you shortly."></textarea>
                <div class="btns">
                  <button class="ok-btn" @click="sendInvestorMail">Send</button>
                  <button class="cancel-btn" @click="() => {
                      showInvestor = false;
                    }
                    ">
                    Cancel
                  </button>
                </div>
              </div>
            </v-layout>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "landing-page",
  data() {
    return {
      showTab1: true,
      showTab2: false,
      showContact: false,
      showInvestor: false,
      investor: {
        mail_from: "",
        mail_body: "",
      },
      contact: {
        mail_from: "",
        mail_body: "",
      },
    };
  },
  methods: {
    sendShit() {
      axios({
        url: "http://127.0.0.1:3000/notify",
        method: "POST",
        data: this.getSubscription,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    goto(path) {
      this.$router.push({ path: path });
    },
    signUp() {
      this.$router.push({ name: "signup" });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    openForum() {
      window.open("https://forum.meritios.com");
    },
    sendContactMail() {
      this.contact.mail_body += "\n\n sent from " + this.contact.mail_from;
      this.$store.dispatch("SEND_CONTACT_MAIL", this.contact);
      this.showContact = false;
    },
    sendInvestorMail() {
      this.investor.mail_body += "\n\n sent from " + this.investor.mail_from;
      this.$store.dispatch("SEND_INVESTOR_MAIL", this.investor);
      this.showInvestor = false;
    },
  },
  computed: {
    ...mapGetters(["getSubscription"]),
  },
};
</script>

<style lang="scss" scoped>
$section_width: 100%;

.text-right {
  text-align: right !important;
  font-family: "Nunito", sans-serif;
}

.text-center {
  text-align: center !important;
  font-family: "Nunito", sans-serif;
}

img {
  cursor: pointer;
}

$section_padding_left: 10px;
$section_padding_right: 10px;
$section_width: 840px;

@media (min-width: 300px) and (max-width: 630px) {
  $section_width: 100%;
}

.__wrapper {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
  background: #fff;

  @media (min-width: 300px) and (max-width: 630px) {
    display: block;
    overflow-y: auto;
  }

  .__toolbar {
    display: flex;
    justify-content: center;
    height: 70px;
    background: linear-gradient(45deg, #1ba5a4, #1885ad);
    padding-right: $section_padding_right;
    padding-left: $section_padding_left;
    padding-top: 10px;
    padding-bottom: 10px;

    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
    }

    .content-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: $section_width;

      .__buttons {
        .sign_in_btn {
          outline: none;
          color: #fff;
          width: 90px;
          height: 35px;
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          background: transparent;
        }

        .register_btn {
          width: 90px;
          height: 35px;
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          border-radius: 0.8vh;
          background-color: #fff;
          color: #00749f;
          outline: none;
          border: none;
        }
      }
    }
  }

  .hero {
    padding-right: $section_padding_right;
    padding-left: $section_padding_left;
    height: calc(100% - 70px);
    background-image: url("../assets/images/backgrounds/bg_welcome2.svg");
    background-origin: content-box;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #178293;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;

    @media (min-width: 300px) and (max-width: 630px) {
      background-position: center;
    }

    .content-wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: $section_width;

      img {
        width: 60px;
        display: none;
        margin-bottom: 30px;

        @media (min-width: 300px) and (max-width: 630px) {
          display: block;
        }
      }

      .phone__buttons {
        margin-bottom: 20px;
        display: none;

        @media (min-width: 300px) and (max-width: 630px) {
          display: block;
        }

        .sign_in_btn {
          outline: none;
          color: #fff;
          width: 90px;
          height: 35px;
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          background: transparent;
        }

        .register_btn {
          width: 90px;
          height: 35px;
          font-family: "Nunito", sans-serif;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          border-radius: 0.8vh;
          background-color: #fff;
          color: #00749f;
          outline: none;
          border: none;
        }
      }

      .about-section {
        .about-col {
          margin-bottom: 60px;

          @media (min-width: 300px) and (max-width: 630px) {
            margin-bottom: 20px;
          }

          h2 {
            color: #fff;
            margin-bottom: 15px;
            font-family: "Nunito", sans-serif;
            font-weight: 800;
          }

          p {
            color: #fff;
            text-align: center;
            font-family: "Nunito", sans-serif;
            font-weight: 300;

            @media (min-width: 300px) and (max-width: 630px) {
              text-align: justify;
            }
          }
        }

        .free-anouncement {
          margin-top: 10px;

          h2 {
            color: #fff;
            margin-bottom: 15px;
            font-family: "Nunito", sans-serif;
            font-weight: 300;
          }
        }
      }
    }
  }

  .main-about {
    height: 200px;
    padding-right: $section_padding_right;
    padding-left: $section_padding_left;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 300px) and (max-width: 630px) {
      height: 200px;
    }

    .main-about-content {
      width: $section_width;

      p {
        font-family: "Nunito", sans-serif;
        text-align: center;
        line-height: 25px;

        @media (min-width: 300px) and (max-width: 630px) {
          line-height: 14px;
          font-size: 12px;
          text-align: justify;
        }
      }
    }
  }

  .__footer {
    height: 72px;
    background: #fff;
    padding-right: $section_padding_right;
    padding-left: $section_padding_left;
    padding-bottom: 15px;
    padding-top: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    @media (min-width: 300px) and (max-width: 630px) {
      height: 72px;
    }

    .footer-logo {
      margin-bottom: 10px;
      display: none;
    }

    .menu {
      list-style: none;
      display: flex;

      li {
        margin-right: 40px;
        color: #000;
        cursor: pointer;
        font-family: "Nunito", sans-serif;
        opacity: 0.8;

        @media (min-width: 300px) and (max-width: 630px) {
          margin-right: 10px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.v-dialog {
  max-width: 400px !important;
}
</style>
<style lang="scss" >
.cover__body {
  padding: 2.8vh;
  width: 100%;

  input {
    height: 5.7vh;
    width: 100%;
    background: #fff;
    font-size: 1.8vh;
    margin: 1.4vh 0;
    font-weight: 300;
    padding: 0 1.4vh;
    outline: none !important;
    border: none !important;
    border-radius: 0.7vh;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;

    &:focus {
      border: none !important;
      outline: none !important;
    }

    &::placeholder {
      opacity: 0.5;
      font-style: italic;
    }
  }

  h2 {
    opacity: 0.51;
    font-family: "Nunito", sans-serif;
    font-size: 1.8vh;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #161615;
  }

  textarea {
    height: 17.9vh;
    width: 100%;
    margin: 1.4vh 0;
    border-radius: 0.7vh;
    resize: none;
    padding: 1.4vh;
    background: #fff;
    outline: none;
    font-family: "Nunito", sans-serif;
    font-size: 1.8vh;
    font-weight: 300;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: rgba(22, 22, 21, 0.51);

    &::placeholder {
      opacity: 0.5 !important;
      font-style: italic;
    }
  }

  .btns {
    .ok-btn {
      width: 10.3vh;
      height: 3.7vh;
      outline: none;
      opacity: 0.97;
      border-radius: 0.6vh;
      font-family: "Nunito", sans-serif;
      font-size: 1.5vh;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      background-image: linear-gradient(to right,
          #1d9694 0%,
          #199295 36%,
          #108798 68%,
          #01759e 98%,
          #00749f 100%);
    }

    .cancel-btn {
      width: 10.3vh;
      height: 3.7vh;
      outline: none;
      opacity: 0.51;
      font-family: "Nunito", sans-serif;
      font-size: 1.5vh;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #161615;
    }
  }
}</style>



